export const state = {
	currency: window.localStorage.getItem('currency') || process.env.VUE_APP_DEFAULT_CURRENCY,
	exchange_rates: [],
	suitcase_total: 0
}
